var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLeftXxsmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6123 5.00456C2.617 4.84015 2.67807 4.68983 2.8096 4.56769L6.46424 0.997605C6.56758 0.89426 6.69911 0.837891 6.85413 0.837891C7.16416 0.837891 7.41313 1.08216 7.41313 1.39219C7.41313 1.54251 7.35206 1.68813 7.24402 1.79618L3.95109 4.99986L7.24402 8.21294C7.34737 8.32098 7.41313 8.4619 7.41313 8.61692C7.41313 8.92695 7.16416 9.17122 6.85413 9.17122C6.69911 9.17122 6.56758 9.11485 6.46424 9.01151L2.8096 5.43673C2.67807 5.30989 2.6123 5.16897 2.6123 5.00456Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftXxsmall);
export default __webpack_public_path__ + "static/media/chevron-left-xxsmall.38f5947c.svg";
export { ForwardRef as ReactComponent };